import { Component, OnInit } from '@angular/core';
import { SeoService } from '../../seoservice/seoservice';

@Component({
  selector: 'app-error-four-zero-four',
  templateUrl: './error-four-zero-four.component.html',
  styleUrls: ['./error-four-zero-four.component.css']
})
export class ErrorFourZeroFourComponent implements OnInit {

  constructor(private seo:SeoService) { }

  ngOnInit(): void {
    this.seo.setTitle("404-页面未找到");

  }

}
